import { clsx } from 'clsx';

import styles from './SignupLayoutHeadingDirectUK.module.css';
import BackToStep from '../../BackToStep/BackToStep';
import MyAccount from '../../MyAccount/MyAccount';

type TSignupLayoutHeadingDirectUK = {
  currentStep: string;
};

const SignupLayoutHeadingDirectUK = ({
  currentStep,
}: TSignupLayoutHeadingDirectUK) => {
  if (currentStep === 'offers') return null;

  return (
    <nav className={clsx(styles.navContainer, styles.directCustomerNav)}>
      {currentStep !== 'documents' && <BackToStep />}

      <MyAccount />
    </nav>
  );
};

export default SignupLayoutHeadingDirectUK;
